import {
  FlexCenter,
  TableHeader,
  TableHeaderCell,
  TextBody,
  TextLabel,
} from "@opensea/ui-kit"
import { StacksFilled } from "@opensea/ui-kit/icons"
import { useTranslations } from "use-intl"
import { CREATE_OFFER_FLOW_TABLE_CLASSNAMES } from "./constants"

type Props = {
  numItems: number
  isReview: boolean
}

export const CreateOfferFlowTableHeader = ({ numItems, isReview }: Props) => {
  const t = useTranslations("wallet.CreateOfferFlowTableHeader")
  return (
    <TableHeader className="h-7 overflow-visible bg-transparent">
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.item}>
        <FlexCenter className="gap-2">
          <StacksFilled size={16} />
          <TextBody className="font-sans lowercase">
            {t("itemCount", { count: numItems })}
          </TextBody>
        </FlexCenter>
      </TableHeaderCell>
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.floor}>
        <TextLabel size="2xs">{t("floor")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}>
        <TextLabel size="2xs">{t("topOffer")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.cost}>
        <TextLabel size="2xs">{t("cost")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}>
        <TextLabel size="2xs">{t("offerTotal")}</TextLabel>
      </TableHeaderCell>
      <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.price}>
        <TextLabel size="2xs">{t("offeredAt")}</TextLabel>
      </TableHeaderCell>
      {numItems > 1 && !isReview && (
        <TableHeaderCell
          className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.remove}
        />
      )}
    </TableHeader>
  )
}
